import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Label } from '@independent-software/typeui/controls/Label';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Section, Viewer } from '../../modules';
import { Stationcategory, StationcategoryFactory, Station } from '../../resource/'; 
import { Output } from '../../controls/Output';
import { ListStations } from '../Station';

const ViewStationcategory = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleStationClick = (station: Station) => {
    navigate(`/stations/${station.id}`);
  }

  return (
    <Viewer<Stationcategory> 
      auth={auth}
      id={parseInt(id)}
      factory={StationcategoryFactory}
      canEdit={(item: any) => false}
      canDelete={(item: any) => false}
      onEdit={null}
      onDelete={null}
      content={(stationcategory: Stationcategory) => 
        <React.Fragment>
          <Section dark padded>
            <Header size="h2">{stationcategory.name}</Header>
          </Section>
          <Tabs underlined>
            <Tabs.Pane label="General">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <>
                    <Output label="Name" hint="Stationcategory name">{stationcategory.name}</Output>
                  </>
                  <>
                  </>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>
            <Tabs.Pane label={<span>Stations <Label size="small">{stationcategory.stations_count}</Label></span>}>
              <ListStations stationcategoryId={stationcategory.id} name="stationcategory_stations" auth={auth} filter={filter} onClick={auth.hasRight('can_view_stations') && handleStationClick}/>
            </Tabs.Pane>
          </Tabs>
        </React.Fragment>}>
    </Viewer>
  );
}

export { ViewStationcategory }
